import { useThemeStore } from "@stores/theme.store";
import { formatValue } from "@utils/helper";
import { Button, Form, Input, Select } from "antd";
import { useEffect, useState } from "react";

export const DebtPaymentPage = () => {
  const { setHeader, setBottomNavigation } = useThemeStore((state) => state);
  const [valUangSaku, setValUangSaku] = useState<string>("0");
  const [tipeVa, setTipeVa] = useState<string>("");

  useEffect(() => {
    setHeader({
      buttonBack: true,

      filter: false,
      title: "Utang",
    });
    setBottomNavigation("hidden");
  }, [setHeader, setBottomNavigation]);

  return (
    <div className="tw-px-4 tw-pb-20">
      <div className="">
        <div id="tab-item">
          <Form className="tw-mb-4" name="basic" layout="vertical">
            <div
              className="tw-mb-2 tw-rounded-lg card"
              style={{
                boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
              }}
            >
              <div className="tw-px-2 tw-py-1">
                <div className="tw-p-2 tw-pb-0 tw-flex tw-justify-between tw-text-xs tw-text-other-600">
                  <span>Utang yang harus dibayar</span>
                </div>
                <div className="tw-p-2 tw-pt-1 tw-flex tw-justify-between tw-items-end tw-font-bold tw-text-other-600">
                  <span className="tw-text-xs">Rp. 000</span>
                  <Form.Item name="bayarspp" className="tw-mb-0">
                    <div className="tw-text-other-600">
                      {/* <div className="tw-text-sm">Bayar (Rp.)</div> */}
                      <Input
                        style={{ width: "90%", float: "right" }}
                        className="tw-text-end"
                        inputMode="numeric"
                        type="text"
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          e.target.value = formatValue(value);
                          setValUangSaku(e.target.value);
                        }}
                        onKeyDown={(event) => {
                          if (!/[0-9]|Backspace|Tab/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        value={valUangSaku}
                      />
                    </div>
                  </Form.Item>
                </div>
              </div>
            </div>

            <div
              className="tw-mb-2 tw-rounded-lg card"
              style={{
                boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
              }}
            >
              <div className="tw-p-3 tw-rounded-lg tw-flex-auto">
                <div className="tw-p-2 tw-pb-0 tw-flex tw-justify-between tw-text-xs tw-text-other-600">
                  <span>Keterangan</span>
                  <span>(opsional)</span>
                </div>

                <Form.Item name="bayarspp" className="tw-mb-0">
                  <div className="tw-p-2 tw-text-other-600">
                    <Input type="text" />
                  </div>
                </Form.Item>
              </div>
            </div>
          </Form>

          <div className="tw-bg-other-100 tw-rounded-lg tw-mt-4 card-body">
            <div className="tw-mb-2 tw-text-xs tw-text-other-600">
              Pilih Bank
            </div>
            <Select
              className="tw-w-full"
              value={tipeVa}
              options={[
                { value: "", label: "pilih bank", disabled: true },
                { value: "BSI", label: "BSI" },
              ]}
              onChange={(newValue) => {
                setTipeVa(newValue);
              }}
            />
          </div>
          <div className="tw-bg-other-100 tw-rounded-lg tw-mt-4 card-body">
            <Button
              type="primary"
              className="tw-h-9 tw-w-full bg-gradient focus:tw-shadow-none hover:tw-bg-other-100 hover:tw-text-primary-hg hover:tw-border-primary-hg"
            >
              Lakukan Pembayaran
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
